import { render, staticRenderFns } from "./ToDevice.vue?vue&type=template&id=97b933b0&"
import script from "./ToDevice.vue?vue&type=script&lang=ts&"
export * from "./ToDevice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports